import { AfterViewInit, Component, viewChild } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AutoComplete } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-tool-autocomplete',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AutoComplete,
    FormlyModule,
  ],
  template: `
    <div class="field">
      <label [for]="field.key" class="block mb-2" *ngIf="to.label">
        {{ to.label }}
        <span *ngIf="to.required" class="text-red-500">*</span>
      </label>
      <p-autocomplete
        #autoCompleteObj
        [forceSelection]="true"
        [suggestions]="to.suggestions"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [field]="to.field"
        [dropdown]="false"
        [style]="{ width: '100%' }"
        (onSelect)="to.onSelect($event)"
        (completeMethod)="to.searchObject(to, $event, field)"
        placeholder="Keresés termék név, kód vagy gyári szám alapján...">
        
        <ng-template let-tool pTemplate="item">
          <div class="flex justify-content-between align-items-center p-2">
            <div>
              <div class="font-bold">{{ tool.productName }}</div>
              <div class="text-sm text-600">
                Kód: {{ tool.productCode }} | Gyári szám: {{ tool.factoryNumber }}
              </div>
              <div class="text-xs text-500">
                Kategória: {{ tool.categoryLabel || 'Egyéb' }} | Raktár: {{ tool.storage }}
              </div>
            </div>
          </div>
        </ng-template>
      </p-autocomplete>
    </div>
  `,
})
export class FormlyToolAutoCompleteComponent extends FieldType<FieldTypeConfig> {
  readonly autoComplete = viewChild<AutoComplete>('autoCompleteObj');
}